import { setupAxiosInstanceForApi } from '../apis/apolyApi/apolyApi';

const setupApolyApiClient = () => {
  setupAxiosInstanceForApi(process.env.REACT_APP_APOLY_API_BASE_URL);
};

export default setupApolyApiClient;
